module.exports = __webpack_public_path__ + "media/customizations/cannerydistrict/logo-new-12674790a93bb9af34ff4cadf96eee10.png";